import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOpen: false,
  title: "",
  detail: "",
  method: "GET",
};

const errorModalSlice = createSlice({
  name: "errorModal",
  initialState,
  reducers: {
    showErrorModal: (state, action) => {
      const { title, detail, method = "GET" } = action.payload;
      state.isOpen = true;
      state.title = title;
      state.detail = detail;
      state.method = method;
    },
    closeErrorModal: () => {
      return initialState;
    },
  },
});

export const { showErrorModal, closeErrorModal } = errorModalSlice.actions;
export default errorModalSlice.reducer;
